import axios from 'axios'

export default {
    loadGameHistory() {
        return axios.get('/load-history')
    },
    loadAvatars() {
        return axios.get('/load-avatars')
    },
    loadUserAchievements() {
        return axios.get('/web-api/load-user-achievements')
    }
}
